'use client';

import { Link } from 'react-router-dom';
import LazyImage from '../LazyImage';
import './styles/planning.css';

const Planning = ({ data }) => {
  return (
    <div className='main-content'>
      <h1>{data?.mainTitle || 'Personalised Financial Advice to Secure Your Future'}</h1>

      {data?.introText?.map((text, index) => (
        <p key={index}>{text}</p>
      ))}

      <h2>{data?.whyChooseTitle || 'Why Choose PFGS as Your Financial Advisor?'}</h2>

      <ul className='reasons-list'>
        {data?.reasons?.map((reason, index) => (
          <li key={index}>
            <strong>{reason.title}</strong> {reason.description}
          </li>
        ))}
      </ul>

      <h2>{data?.servicesTitle || 'Our Financial Services'}</h2>

      {data?.services?.map((service, index) => (
        <div key={index} className='service-item'>
          <h3>{service.title}</h3>
          <p>{service.description}</p>
          {service.bullets && (
            <ul className='service-bullets'>
              {service.bullets.map((bullet, bulletIndex) => (
                <li key={bulletIndex}>{bullet}</li>
              ))}
            </ul>
          )}
        </div>
      ))}

      <section className='who-we-help-section'>
        {/* Who We Help Section */}
        <div className='section-spacing'>
          <h2 className='who-we-help-title'>{data?.whoWeHelpTitle || 'Who We Help'}</h2>
          <ul className='help-list'>
            {data?.whoWeHelp?.map((item, index) => (
              <li key={index} className='help-item'>
                <span className='help-bullet'>•</span>
                <div className='help-content'>
                  <span className='help-title'>{item.title}</span>
                  <span> {item.description}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* About PFGS Section */}
        <div className='section-spacing'>
          <h2 className='about-title'>{data?.aboutTitle || 'About PFGS'}</h2>
          <div className='about-content'>
            {data?.aboutText?.map((text, index) => (
              <p key={index} className='about-text'>
                {text}
              </p>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className='cta-section'>
          <h2 className='cta-title'>{data?.ctaTitle || "Let's Build Your Financial Future Together"}</h2>
          <p className='cta-text'>
            {data?.ctaText || 'Take the first step toward financial confidence. Contact PFGS today for a free initial consultation.'}
          </p>
          <Link to='/contact' className='btn btn-hero-primary'>
            Contact Us
          </Link>
          <div className='cta-image-container'>
            <LazyImage src='/contact-image.webp' alt='PFGS Financial Team' className='cta-image' />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Planning;
